import { createContext, useContext } from "react";

/**
 * Host element for a sticky `TableActionRibbon`.
 *
 * When this context provides a DOM node, a ribbon rendered with
 * `sticky` portals its content into that node instead of rendering
 * inline. The Scenario Results page uses this to collect the
 * (table-owned) ribbon into a single sticky "chrome" parent alongside
 * the Tabs nav, so the browser stacks nav + ribbon with no per-element
 * offset math. The default (`null`) means "no host" — the ribbon
 * renders inline (legacy / standalone sticky tables).
 */
export const RibbonSlotContext = createContext<HTMLElement | null>(null);

export const useRibbonSlot = (): HTMLElement | null =>
    useContext(RibbonSlotContext);
